import { ReactNode, createContext } from "react";
import { useState, useEffect } from "react";
import { fetchUserAttributes } from 'aws-amplify/auth';
import localforage from "localforage";
import log from "loglevel";

const FloorContext = createContext({
	floor: -1,
	setFloor: (floor: number) => {},
});

type FloorContextProps = {
  children?: ReactNode
};

export const FloorProvider = ({ children }: FloorContextProps) => {

  const [floor, setFloor] = useState<number>(-1);

  useEffect(() => {

    localforage.getItem<string>("FLOOR")
    .then((value: string| null) => {
      if (value !== null) {
        log.info("Retrieved floor from storage:", value);
        setFloor(parseInt(value));
      } else {
        log.info("No floor in storage, fetching from Cognito");
        fetchUserAttributes()
          .then((userAttributes) => {
            if (userAttributes.nickname !== undefined) {
              const floorValue = parseInt(userAttributes.nickname);
              log.info("Retrieved floor from Cognito:", floorValue);
              setFloor(floorValue);
              localforage.setItem("FLOOR", userAttributes.nickname)
                .catch((err) => log.error("Error storing floor", err));
            } else {
              log.warn("No floor (nickname) attribute found in Cognito");
            }
          })
          .catch((error) => {
            log.warn("Error fetching user attributes for floor", error);
          });
      }
    })
    .catch((err: unknown) => {
      console.error("Error retrieving floor from storage", err);
    });

    return () => {
    };
  }, []);   

  return (
    <FloorContext.Provider value={{floor, setFloor}}>
      {children}
    </FloorContext.Provider>
  );
};

export default FloorContext;
